var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 540",
    width: 960,
    height: 540,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 540,
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#6b62fc",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#8c7bfd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#6b62fc",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#8c7bfd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#a794fe",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#c0aeff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#a794fe",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_5",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#c0aeff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#d6c9ff",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_6",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#ebe4ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#d6c9ff",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_7",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#ebe4ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#6b62fc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#3c4afa",
    stopOpacity: 1
  })))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#6b62fc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#8c7bfd",
    stopOpacity: 1
  })))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#a794fe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#8c7bfd",
    stopOpacity: 1
  })))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#a794fe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#c0aeff",
    stopOpacity: 1
  })))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_5",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#d6c9ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#c0aeff",
    stopOpacity: 1
  })))), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_6",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#d6c9ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#ebe4ff",
    stopOpacity: 1
  })))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_7",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#ebe4ff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960, 540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-486 0C-464.7 -62.4 -443.4 -124.9 -408.4 -169.1C-373.3 -213.4 -324.5 -239.5 -289.2 -289.2C-253.9 -338.9 -231.9 -412.3 -186 -449C-140 -485.7 -70 -485.9 0 -486L0 0Z",
    fill: "#f5f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-425.2 0C-406.6 -54.6 -388 -109.3 -357.3 -148C-326.7 -186.7 -284 -209.6 -253.1 -253.1C-222.1 -296.6 -203 -360.7 -162.7 -392.9C-122.5 -425 -61.3 -425.1 0 -425.2L0 0Z",
    fill: "#e1d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-364.5 0C-348.5 -46.8 -332.5 -93.7 -306.3 -126.9C-280 -160.1 -243.4 -179.6 -216.9 -216.9C-190.4 -254.2 -174 -309.2 -139.5 -336.8C-105 -364.3 -52.5 -364.4 0 -364.5L0 0Z",
    fill: "#cbbbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-303.7 0C-290.4 -39 -277.1 -78.1 -255.2 -105.7C-233.3 -133.4 -202.8 -149.7 -180.8 -180.8C-158.7 -211.8 -145 -257.7 -116.2 -280.6C-87.5 -303.6 -43.8 -303.7 0 -303.7L0 0Z",
    fill: "#b4a1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-243 0C-232.3 -31.2 -221.7 -62.4 -204.2 -84.6C-186.7 -106.7 -162.3 -119.7 -144.6 -144.6C-126.9 -169.5 -116 -206.1 -93 -224.5C-70 -242.9 -35 -242.9 0 -243L0 0Z",
    fill: "#9a88fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-182.2 0C-174.3 -23.4 -166.3 -46.8 -153.1 -63.4C-140 -80 -121.7 -89.8 -108.5 -108.5C-95.2 -127.1 -87 -154.6 -69.7 -168.4C-52.5 -182.2 -26.3 -182.2 0 -182.2L0 0Z",
    fill: "#7d6ffd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-121.5 0C-116.2 -15.6 -110.8 -31.2 -102.1 -42.3C-93.3 -53.4 -81.1 -59.9 -72.3 -72.3C-63.5 -84.7 -58 -103.1 -46.5 -112.3C-35 -121.4 -17.5 -121.5 0 -121.5L0 0Z",
    fill: "#5756fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.7 0C-58.1 -7.8 -55.4 -15.6 -51 -21.1C-46.7 -26.7 -40.6 -29.9 -36.2 -36.2C-31.7 -42.4 -29 -51.5 -23.2 -56.1C-17.5 -60.7 -8.8 -60.7 0 -60.7L0 0Z",
    fill: "#3c4afa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486 0C439.8 48 393.6 96 375.1 155.4C356.6 214.8 365.7 285.5 338.7 338.7C311.7 391.9 248.5 427.4 186 449C123.5 470.6 61.8 478.3 0 486L0 0Z",
    fill: "#f5f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3 0C384.8 42 344.4 84 328.2 135.9C312 187.9 320 249.9 296.4 296.4C272.7 342.9 217.4 374 162.7 392.9C108.1 411.8 54 418.5 0 425.3L0 0Z",
    fill: "#e1d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5 0C329.9 36 295.2 72 281.3 116.5C267.4 161.1 274.3 214.2 254 254C233.8 293.9 186.3 320.5 139.5 336.8C92.6 353 46.3 358.7 0 364.5L0 0Z",
    fill: "#cbbbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.8 0C274.9 30 246 60 234.4 97.1C222.9 134.2 228.6 178.5 211.7 211.7C194.8 244.9 155.3 267.1 116.2 280.6C77.2 294.1 38.6 298.9 0 303.8L0 0Z",
    fill: "#b4a1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 0C219.9 24 196.8 48 187.5 77.7C178.3 107.4 182.9 142.8 169.4 169.4C155.8 195.9 124.2 213.7 93 224.5C61.8 235.3 30.9 239.2 0 243L0 0Z",
    fill: "#9a88fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3 0C164.9 18 147.6 36 140.7 58.3C133.7 80.5 137.1 107.1 127 127C116.9 146.9 93.2 160.3 69.7 168.4C46.3 176.5 23.2 179.4 0 182.3L0 0Z",
    fill: "#7d6ffd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5 0C110 12 98.4 24 93.8 38.8C89.1 53.7 91.4 71.4 84.7 84.7C77.9 98 62.1 106.8 46.5 112.3C30.9 117.7 15.4 119.6 0 121.5L0 0Z",
    fill: "#5756fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 0C55 6 49.2 12 46.9 19.4C44.6 26.8 45.7 35.7 42.3 42.3C39 49 31.1 53.4 23.2 56.1C15.4 58.8 7.7 59.8 0 60.8L0 0Z",
    fill: "#3c4afa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack1);
export default __webpack_public_path__ + "static/media/back1.6f1f4b72f8bac2725fe02bb13a937049.svg";
export { ForwardRef as ReactComponent };